export const CURRENT_PAGE = "CURRENT_PAGE"
export const COMMUNITY_FORM_SUBMIT = "Community_form"
export const ADJUSTED_PLANS_SLIDER = "Adjusted Plans Slider"
